var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar-items-list',{attrs:{"api-url":_vm.apiUrl,"back-to":{ name: 'projects.index' },"header":_vm.$t('Components'),"model-type":"component","show-clone-options":""}})}
var staticRenderFns = []

export { render, staticRenderFns }